// Imports
import React, { useContext } from "react"
import "react-responsive-carousel/lib/styles/carousel.min.css"
import { Button, useVerticalTextSlider } from "@molecules"
import { BrandLogo } from "@icons"
import { ModalContext } from "../../modal/ModalContenxtProvider"

const HeroContent = ({
  heading01,
  heading03,
  cta,
  ctaLink,
  rollingText,
  indicator,
  logo,
}) => {
  const slider = useVerticalTextSlider(rollingText, 5000)
  const { setIsModalOpen } = useContext(ModalContext)

  const onClick = (e) => {
    e.preventDefault()
    setIsModalOpen(true)
  }

  return (
    <>
      {logo && (
        <div className="hero-logo">
          <BrandLogo />
        </div>
      )}
      <div className="hero-text">
        <h1> {heading01} </h1>
        <div className="hero-text__rolling">{slider}</div>
        <h1> {heading03} </h1>
      </div>
      <div className="hero-action">
        <Button
          iconPosition="after"
          text={cta.text}
          url={cta.to}
        />
        <a href={ctaLink.to} onClick={onClick}>
          {ctaLink.text}
        </a>
      </div>
      {indicator && (
        <div className="hero-indicator">
          <span></span>
          <span className="active"></span>
        </div>
      )}
    </>
  )
}

export default HeroContent
